module.exports = __webpack_public_path__ + "static/img/0005.c6e5515.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/0005.png
// module id = rrTR
// module chunks = 1